export default __webpack_public_path__ + "static/media/washers.78b5fa63.png";